"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Channel = require("./Channel");
Object.keys(_Channel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Channel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Channel[key];
    }
  });
});